import styled from 'astroturf/react'

import RoundIcon from 'components/round_icon'
import _Container from "styles-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/calendar_provider_icon/styles.js?styleId=Container";


export const Container = /*#__PURE__*/styled(RoundIcon, null, {
  displayName: "Container",
  styles: _Container,
  attrs: ({
    provider,
    ...props
  }) => ({
    ...props,
    name: provider,
    provider
  })
})
